import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


interface PageTitleProps {
  title?: string; // タイトルはあってもなくてもOKにする
}


const PageTitle = ({ title }: PageTitleProps ) => {
  const loc = useLocation();

  useEffect(() => {
    const baseTitle = "毒と花と6畳間";
    
    // titleが渡されていればそれを使用、なければベースタイトルのみ
    if (title && title.trim() !== "") {
      document.title = `${title} | ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }

  }, [title, loc.pathname]); // 監視対象も loc.pathname に変更

  return null;
};

export default PageTitle;